// extracted by mini-css-extract-plugin
export default {"businessCard":"BusinessCard_businessCard__Wtuho","content":"BusinessCard_content__nX+jA","padding":"BusinessCard_padding__2i3pS"};